import * as React from "react";
import { FilterContextType, FilterParams } from "../../components/context/filter";
import { AvailableCreditsChart } from "./charts/AvailableCreditsChart";
import { UsedCreditsChart } from "./charts/UsedCreditsChart";


export class CreditDashboard extends React.Component {

    static contextType = FilterContextType

    context: FilterParams
    previousContext: FilterParams;

    constructor(p: any) {
        super(p);
        this.state = {

        }
    }

    componentDidUpdate() {
        if (this.previousContext !== this.context) {
        }
        this.previousContext = this.context;
    }

    componentDidMount() {
        this.previousContext = this.context;
    }

    render() {
        return <div className='dashboard'>
            <div className='charts'>
                <div className='bpm-container'>
                    <div className='row'>
                        <div className='col'>
                            <AvailableCreditsChart />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col'>
                            <UsedCreditsChart />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/pages/Credit/CreditDashboard.tsx